import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Checkbox } from 'sharedComponents/Checkbox';
import { OrganizationSelector } from './OrganizationSelector';
import { AssetGroupSelector } from './AssetGroupSelector';
import { SiteSelector } from './SiteSelector';
import { CountrySelector } from './CountrySelector';
import LoadingStatusWrapper from 'sharedComponents/WithLoadingStatus/LoadingStatusWrapper';
import { mapToFormattedCiamOrganiations } from './OrganizationSelector/helpers';
import { apiCallStatus } from 'helpers/constants';

const GeneralFilterEditComponent = (props) => {
    const { t: translate } = useTranslation();
    const [isCiamSearchOrganizations, setIsCiamSearchOrganizations] = useState(false);

    const { selectedFilters,
        selectedOrganization,
        availableAssetGroups,
        organizations,
        availableCountries,
        availableSites,
        ciamSearchOrganizations
    } = props.model;

    const {
        countries: selectedCountries,
        sites: selectedSites,
        assetGroups: selectedAssetGroups,
        sitesChecked,
        assetGroupChecked
    } = selectedFilters;


    const {
        organizationsLoadingStatus,
        sitesLoadingStatus,
        assetGroupsLoadingStatus,
        ciamSearchOrganizationLoadingStatus,
    } = props.model.loadingData;

    const {
        setSelectedFilters,
        getCiamSearchOrganizations,
    } = props.actions;

    const isNonPowertrainOrganization = selectedOrganization?.isPowertrainOrganization === false;

    const onChangeOrganization = (newOrganization) => {
        const organizations = [newOrganization];
        props.setSelectedOrg(newOrganization);
        setSelectedFilters(
            {
                ...selectedFilters,
                assetGroupChecked: false,
                sitesChecked: true,
                organizations,
                countries: [],
                sites: [],
                assetGroups: []
            }
        );
    };

    const onChangeCountry = (countries) => {
        setSelectedFilters(
            {
                ...selectedFilters,
                countries,
                sites: [],
            }
        );
    };

    const onChangeSite = (sites) => {
        setSelectedFilters(
            {
                ...selectedFilters,
                sites
            }
        );
    };

    const onChangeAssetGroup = (assetGroups) => {
        setSelectedFilters(
            {
                ...selectedFilters,
                assetGroups
            }
        );
    };

    const onSearchFromNewOrganizations = (value) => {
        if (isCiamSearchOrganizations) {
            setIsCiamSearchOrganizations(false);
        } else {
            getCiamSearchOrganizations({ nameFilter: value }, () => setIsCiamSearchOrganizations(true));
        }
    };

    const organizationsList = isCiamSearchOrganizations ? mapToFormattedCiamOrganiations(ciamSearchOrganizations) : organizations;

    return <Container className='filter-edit-container'>
        <LoadingStatusWrapper
            loadingStatus={[
                organizationsLoadingStatus,
                sitesLoadingStatus,
                assetGroupsLoadingStatus,
                ciamSearchOrganizationLoadingStatus
            ]}
            transparent
            useCustomAnchor>
            <div className='general-filter-organization-filter-label'>
                {translate('ABB.Powertrain.Frontend.generalFiltersOrganizationFilter')}
            </div>
            <form role='form'>
                <Row className='main-section-row g-0'>
                    <Col md={12} className='sub-section-row'>
                        {/* <Col xs={1} md={1} className='px-3'>
                        </Col> */}
                        <Col md={12} className='px-3'>
                            <div className='filter-form-group'>
                                <label htmlFor='organizations-select'
                                    className='filter-form-label'>
                                    {translate('ABB.Powertrain.Frontend.generalFiltersOrganizationsLabel')}
                                </label>
                                <OrganizationSelector
                                    onChange={onChangeOrganization}
                                    options={organizationsList}
                                    selectedOrganization={selectedOrganization}
                                    inputId='organizations-select'
                                    name='organizations-select'
                                    onSearchFromNewOrganizations={onSearchFromNewOrganizations}
                                    isCiamSearchOrganizations={isCiamSearchOrganizations}
                                    isLoading={ciamSearchOrganizationLoadingStatus === apiCallStatus.LOADING}
                                />
                                {isNonPowertrainOrganization &&
                                    <div className='new-organization-info'>
                                        {translate('ABB.Powertrain.Frontend.generalFiltersNewOrganizationInfo')}
                                    </div>
                                }
                            </div>
                        </Col>
                    </Col>
                    <Col md={12} className='sub-section-row'>
                        {/* <Col xs={1} md={1}>
                        </Col> */}
                        <Col md={12} className='px-3'>
                            <div className='filter-form-group'>
                                <label htmlFor='sites-select'
                                    className='filter-form-label'>
                                    {translate('ABB.Powertrain.Frontend.generalFiltersSitesLabel')}
                                </label>
                                <SiteSelector
                                    sitesChecked={sitesChecked}
                                    options={availableSites}
                                    value={selectedSites}
                                    onChange={onChangeSite}
                                    inputId='sites-select'
                                    name='sites-select'
                                />
                            </div>
                        </Col>
                    </Col>
                </Row>

                {props.isVisibilityAdvancedFilter &&
                    <>
                        <Row className='main-section-row g-0'>
                            <Col md={12} className='sub-section-row'>
                                <Col xs={1} md={1} className='px-3'>
                                    <Checkbox
                                        id={'countries_filter_checkbox'}
                                        checked={sitesChecked}
                                        onToggle={() => props.actions.setSelectedFilters({ ...selectedFilters, countries: [], sites: [], sitesChecked: !sitesChecked })}
                                        width={'16px'}
                                        height={'16px'}
                                    />
                                </Col>
                                <Col md={11} className='px-3'>
                                    <div className='filter-form-group'>
                                        <label htmlFor='countries-select'
                                            className='filter-form-label'>
                                            {translate('ABB.Powertrain.Frontend.countryNameLabel')}
                                        </label>
                                        <CountrySelector
                                            sitesChecked={sitesChecked}
                                            onChange={onChangeCountry}
                                            options={availableCountries}
                                            value={selectedCountries}
                                            inputId='countries-select'
                                            name='countries-select'
                                        />
                                    </div>
                                </Col>
                            </Col>
                        </Row >
                        <Row className='main-section-row g-0'>
                            <Col md={12} className='sub-section-row'>
                                <Col xs={1} md={1} className='px-3'>
                                    <Checkbox
                                        id={'assetgroup_filter_checkbox'}
                                        checked={assetGroupChecked}
                                        onToggle={() => setSelectedFilters({ ...selectedFilters, assetGroups: [], assetGroupChecked: !assetGroupChecked })}
                                        width={'16px'}
                                        height={'16px'}
                                    />
                                </Col>
                                <Col md={11} className='px-3'>
                                    <div className='filter-form-group'>
                                        <label htmlFor='asset-group-select'
                                            className='filter-form-label'>
                                            {translate('ABB.Powertrain.Frontend.generalFiltersAssetGroupsLabel')}
                                        </label>
                                        <AssetGroupSelector
                                            assetGroupChecked={assetGroupChecked}
                                            onChange={onChangeAssetGroup}
                                            options={availableAssetGroups}
                                            value={selectedAssetGroups}
                                            inputId='asset-group-select'
                                            name='asset-group-select'
                                        />
                                    </div>
                                </Col>
                            </Col>
                        </Row>
                    </>
                }
            </form >
        </LoadingStatusWrapper >
    </Container >;
};

GeneralFilterEditComponent.propTypes = {
    actions: PropTypes.shape({
        setSelectedFilters: PropTypes.func.isRequired,
        getCiamSearchOrganizations: PropTypes.func.isRequired
    }).isRequired,
    model: PropTypes.shape({
        selectedOrganization: PropTypes.object,
        availableAssetGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
        availableCountries: PropTypes.arrayOf(PropTypes.object).isRequired,
        availableSites: PropTypes.arrayOf(PropTypes.object).isRequired,
        loadingData: PropTypes.shape({
            organizationsLoadingStatus: PropTypes.string,
            sitesLoadingStatus: PropTypes.string,
            assetGroupsLoadingStatus: PropTypes.string,
            ciamSearchOrganizationLoadingStatus: PropTypes.string
        }).isRequired,
        organizations: PropTypes.arrayOf(PropTypes.object).isRequired,
        selectedFilters: PropTypes.shape({
            assetGroups: PropTypes.array.isRequired,
            assetGroupChecked: PropTypes.bool.isRequired,
            countries: PropTypes.array.isRequired,
            organizations: PropTypes.array.isRequired,
            sites: PropTypes.array.isRequired,
            sitesChecked: PropTypes.bool.isRequired
        }).isRequired,
        ciamSearchOrganizations: PropTypes.arrayOf(PropTypes.object).isRequired
    }).isRequired,
    isVisibilityAdvancedFilter: PropTypes.bool.isRequired,
    setSelectedOrg: PropTypes.func.isRequired
};

export default GeneralFilterEditComponent;
